import Modal from '@/components/base/Modal';

type Props = {
  open: boolean;
  studentName: string;
  studentGrade?: string | null;
  absenceDate: string;
  reason: string;
  classInfo: string;
  completedDate: string;
  completedTime: string;
  onClose: () => void;
  onEdit?: () => void;
};

export default function MakeupCompletedModal({
  open,
  studentName,
  studentGrade,
  absenceDate,
  reason,
  classInfo,
  completedDate,
  completedTime,
  onClose,
  onEdit,
}: Props) {
  return (
    <Modal open={open} title={`${studentName} 보충 완료`} onClose={onClose}>
      <div className="flex items-center gap-3 rounded-lg border border-primary-200 bg-primary-50 px-4 py-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
          <i className="ri-checkbox-circle-line text-2xl"></i>
        </span>
        <div className="min-w-0">
          <p className="text-sm font-bold text-foreground-950">
            보충 수업을 완료했어요
          </p>
          <p className="mt-0.5 text-xs text-foreground-500">
            아래에서 언제 완료했는지 확인할 수 있어요.
          </p>
        </div>
      </div>

      <div className="mt-4 space-y-3">
        <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-semibold text-foreground-900">{studentName}</span>
            {studentGrade && (
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">
                {studentGrade}
              </span>
            )}
          </div>
          <div className="mt-2 space-y-1.5 text-sm">
            <p className="flex items-start gap-2 text-foreground-600">
              <i className="ri-calendar-close-line mt-0.5 text-base text-accent-600"></i>
              <span>
                <span className="font-medium text-foreground-700">결석일</span> {absenceDate}
              </span>
            </p>
            <p className="flex items-start gap-2 text-foreground-600">
              <i className="ri-bookmark-line mt-0.5 text-base text-secondary-600"></i>
              <span>
                <span className="font-medium text-foreground-700">결석사유</span> {reason}
              </span>
            </p>
            {classInfo && (
              <p className="flex items-start gap-2 text-foreground-600">
                <i className="ri-time-line mt-0.5 text-base text-primary-600"></i>
                <span>
                  <span className="font-medium text-foreground-700">결석 수업</span> {classInfo}
                </span>
              </p>
            )}
          </div>
        </div>

        <div className="rounded-lg border border-primary-300 bg-white px-4 py-3">
          <p className="text-xs font-semibold text-primary-700">보충 완료 정보</p>
          <div className="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div className="rounded-md bg-primary-50 px-3 py-2.5">
              <p className="text-xs text-foreground-500">완료 날짜</p>
              <p className="mt-0.5 text-base font-bold text-foreground-950">{completedDate}</p>
            </div>
            <div className="rounded-md bg-primary-50 px-3 py-2.5">
              <p className="text-xs text-foreground-500">완료 시간</p>
              <p className="mt-0.5 text-base font-bold text-foreground-950">{completedTime}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          {onEdit && (
            <button
              onClick={onEdit}
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100"
            >
              <i className="ri-pencil-line"></i> 완료 일정 수정
            </button>
          )}
        </div>
        <button
          onClick={onClose}
          className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          확인
        </button>
      </div>
    </Modal>
  );
}